export default "__VITE_ASSET__2ceed860__"